var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"flex-shrink-0 p-2 transition-colors focus:text-red-500 lg:hover:text-red-500",on:{"click":_vm.onClick}},[_c('inline-svg',{staticClass:"fill-current",attrs:{"src":"/img/icon-back.svg"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }